import { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import countries from '@configs/bulkPurchaseCountry';

const useStyles = makeStyles((theme) => ({
	rootFirstSelect: {
		padding: "10px 12px"
	},
	rootSecondSelect: {
		padding: "10px 80px"
	}
}));

export const CountryList = (props) => {
	const classes = useStyles();
	const { value, onChange, width, disabled, variant, label, background, compactView } = props;

	const changeHandler = (e) => {
		if (e && e.target && e.target.value) {
			onChange(e.target.value);
		}
	};

	return (
		<FormControl variant={variant} sx={{ width: width ? width : '100%' }}>
			{label && <InputLabel id="bulk-country-list-label">{label}</InputLabel>}
			<Select
				onChange={changeHandler}
				placeholder="Select Curreny"
				value={countries.length > 0 ? value : ''}
				label={label}
				disabled={disabled}
				sx={{ background: background }}
				classes={{ select: compactView ? classes.rootFirstSelect : '' }}
			>
				{countries.map(({ code, name }) => (
					<MenuItem value={code} key={`option-id-${code}`}>
						{name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
